<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
        >
          Add Product
        </v-card-title>
        <v-container grid-list-sm class="pa-4">
          <v-layout align-center row wrap>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field label="Name" v-model="name"></v-text-field>
              <v-text-field type="number" label="Price" v-model="price"></v-text-field>
              <v-text-field type="number" label="Commission" v-model="commission"></v-text-field>
              <v-text-field type="number" label="Default amount" v-model="amount"></v-text-field>
              <v-select
                :items="usersList"
                v-model="selectedUser"
                label="Select user"
              >
                <template slot="item" slot-scope="props">
                  {{ props.item.name }} - {{ props.item.roles | normalizeRoles }}
                </template>
                <template slot="selection" slot-scope="props">
                  {{ props.item.name }} - {{ props.item.roles | normalizeRoles }}
                </template>
              </v-select>
              <v-combobox
                v-if="categoriesList"
                v-model="selectedCategory"
                :loading="loading.categories"
                :items="categoriesList"
                :search-input.sync="categorySearch"
                hide-selected
                label="Select category"
              >
                <template slot="item" slot-scope="props">
                  {{ props.item.text }}
                </template>
                <template slot="selection" slot-scope="props">
                  {{ props.item.text }}
                </template>
                <template v-slot:no-data>
                  <v-list-tile class="pointer">
                    <v-list-tile-content>
                      <v-list-tile-title @click="addCategory">
                        No results matching "<strong>{{ categorySearch }}</strong>". <kbd>Click</kbd> to create a new category
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <template v-slot:append-outer>
                  <v-checkbox class="checkboxParentCategory" v-model="setParentId" :label="`Set parent category`"></v-checkbox>
                </template>
              </v-combobox>
            </v-flex>

            <v-flex xs12>
              <v-combobox
                v-if="categoriesList && setParentId"
                v-model="selectedParentCategory"
                :loading="loading.categories"
                :items="excludeSelectedCategory"
                hide-selected
                label="Select parent category"
              >
                <template slot="item" slot-scope="props">
                  {{ props.item.text }}
                </template>
                <template slot="selection" slot-scope="props">
                  {{ props.item.text }}
                </template>
              </v-combobox>
            </v-flex>


            <v-flex xs12>
              <input type="file" style="display: none" ref="csvUploadInput" @change="uploadCsv">
              <v-btn
                :loading="loading.uploadCsvBtn"
                :disabled="disabled.uploadCsvBtn"
                @click.native="onClickUploadCsvBtn"
              >
                {{ labels.uploadCsvBtn }}
                <v-icon right dark>cloud_upload</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn color="primary" v-if="!disabled.saveBtn" @click="saveNew">Save</v-btn>
          <v-btn flat @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import CrudAPI from '@/api/resources/crud'
  import AppMainDialog from '@/components/AppMainDialog'
  import AddButtonMixins from '@/mixins/AddButton'
  import usersAPI from '@/api/user'
  import servicesAPI from '@/api/resources/services'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    components: { AppMainDialog },
    mixins: [ AddButtonMixins ],
    data () {
      return {
        resources: 'products',
        setParentId: false,
        loading: {
          uploadCsvBtn: null,
          categories: false
        },
        disabled: {
          uploadCsvBtn: null,
          saveBtn: false
        },
        labels: {
          uploadCsvBtn: 'Or upload CSV'
        },
        dialog: false,
        dialogMessage: '',
        usersList: [],
        name: null,
        amount: null,
        price: null,
        commission: null,
        selectedUser: null,
        selectedCategory: null,
        selectedParentCategory: null,
        dialogOpen: false,
        categorySearch: null
      }
    },
    computed: {
      ...mapGetters({
        categoriesList: 'productsCategories',
        categoryById: 'getProductCategoryById'
      }),
      excludeSelectedCategory () {
        if (this.selectedCategory === null) return this.categoriesList
        return _.filter(this.categoriesList, (c) => { return c.id !== this.selectedCategory.id })
      }
    },
    watch: {
      selectedCategory (c) {
        if (c.parent_id === null) {
          this.setParentId = false
          this.selectedParentCategory = null
          return
        }
        this.setParentId = true
        this.selectedParentCategory = this.categoryById(parseInt(this.selectedCategory.parent_id))
      },
      selectedParentCategory (p) {
        if (this.selectedCategory === null || p === null) return
        this.editCategory()
      },
      setParentId (v) {
        if (v === false && this.selectedCategory !== null && this.selectedParentCategory !== null) {
          this.selectedParentCategory = null
          this.editCategory()
        }
      }
    },
    methods: {
      addCategory () {
        this.loading.categories = true
        this.$store.dispatch('createProductCategory', this.categorySearch).then(() => {
          this.$store.dispatch('getProductsCategories')
          this.loading.categories = false
        })
      },
      editCategory () {
        this.loading.categories = true
        this.$store.dispatch('editProductCategory', { id: this.selectedCategory.id,
          parent_id: this.selectedParentCategory !== null ? this.selectedParentCategory.id : null
        }).then(() => {
          this.$store.dispatch('getProductsCategories')
          this.loading.categories = false
        }, () => {
          this.$store.dispatch('getProductsCategories')
          this.loading.categories = false
        })
      },
      uploadCsv (event) {
        this.loading.uploadCsvBtn = true
        this.disabled.uploadCsvBtn = true
        this.disabled.saveBtn = true

        let formData = new FormData()

        formData.append('csv_file', event.target.files[0])

        servicesAPI.uploadProductsWithCsv(formData).then(() => {
          this.loading.uploadCsvBtn = false
          this.disabled.uploadCsvBtn = false
          this.disabled.saveBtn = false
          this.labels.uploadCsvBtn = 'Uploaded!'

          this.$bus.$emit('resource-added')
        }, () => {})
      },
      saveNew () {
        this.disabled.saveBtn = true
        // TODO move to backend
        let payload = {
          name: this.name,
          is_available: true,
          is_product: true,
          price: this.price,
          commission: this.commission,
          amount: this.amount,
          users_id: this.selectedUser,
          is_vendor: false,
          categories_id: this.selectedCategory.id
        }

        let result = CrudAPI.dfsResourceStore(this.resources, payload)

        result.then(() => {
          this.disabled.saveBtn = false
        }).then(this.saveNewSuccess, this.saveNewError)
      },
      onClickUploadCsvBtn () {
        this.$refs.csvUploadInput.click()
      },
      emptyForm () {
        this.setParentId = false
        this.name = null
        this.amount = null
        this.price = null
        this.commission = null
        this.selectedUser = null
        this.selectedCategory = null
        this.selectedParentCategory = null
        this.categorySearch = null
      }
    },
    // TODO move to mixins along with EditProducts
    filters: {
      normalizeRoles (items) {
        return items && items.length > 0 ? items.map(mapping => mapping.name).join() : ''
      }
    },
    created () {
      if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories')
      usersAPI.loadUsers().then(result => {
        this.usersList = result
      }, () => {})
    },
    mounted () {
      this.emptyForm()
    }
  }
</script>

<style>
  .checkboxParentCategory {
    margin-top: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// AddProductButton.vue?edd99f66